const messages = {
  title: "Dobrodošli Bridgestone <span class='text-danger'>PLUS</span>",
  termsAndConditions: "Pogoji in določila",
  accept: "Sprejmi",
  decline: "Zavrni",
  dataModal:
    "Da bi prilagodili to ponudbo vašim interesom, vas prijazno prosimo, da na kratko navedete svoje interese za izdelke ali poslovna področja.",
  scrollToAccept: "Pomaknite se navzdol, da sprejmete naše pogoje za nadaljevanje",
  welcomeMessage: "Dobrodošli v Bridgestone Plus",
  tailorOffer:
    "Da bi prilagodili to ponudbo vašim interesom, vas prijazno prosimo, da na kratko navedete svoje interese za izdelke ali poslovna področja.",
  bussinessType:
    "Da bi prilagodili to ponudbo vašim interesom, vas prijazno prosimo, da na kratko navedete svoje interese za izdelke ali poslovna področja.",
  selectAreas: "Prosimo izberite iz naslednjih področij",
  multipleAnswers: "(možni so večkratni odgovori):",
  personalPreferences: "Osebne preference",
  carTyres: "Pnevmatike za avtomobile, SUV-je, komercialna vozila",
  motorcyclesTyres: "Pnevmatike za motocikle",
  truckBusTyres: "Pnevmatike za tovornjake in avtobuse",
  agricultureTyres: "Pnevmatike za kmetijska vozila",
  otrTyres: "OTR pnevmatike",
  save: "Shrani",
  businessRelationship: "Kakšno je vaše poslovno razmerje z Bridgestone?",
  selectRelationship: "Prosimo izberite*:",
  tradingPartner: "Sem trgovinski partner, ki...",
  tradingPartnerDirect: "... naroča neposredno pri Bridgestone",
  tradingPartnerIndirect: "... naroča posredno (preko veleprodajalcev, itd.)",
  tradingPartnerBoth: "... naroča tako neposredno kot posredno",
  fleetResponsibleDirect: "Sem upravitelj flote, ki...",
  fleetResponsibleIndirect: "... naroča posredno (preko trgovine ali veleprodaje)",
  fleetResponsibleBoth: "... naroča tako neposredno kot posredno",
  noBusinessRelationship:
    "<b>Nimam poslovnega razmerja z Bridgestone</b> (niti neposredno niti posredno)",
  yourCustomerNumber: "Vaša Bridgestone številka stranke*:",
  enterCustomerNumber: "Vnesite vašo številko stranke",
  waitPersonalisedView:
    "Prosimo počakajte trenutek, vaš prilagojeni pogled na BRIDGESTONE PLUS bo generiran.",
  personalised: "PRILAGOJENO",
  plusInfo:
    "Tu lahko najdete informacije o vašem Plus računu in vaši Plus prejeti pošti.",
  continue: "Nadaljuj",
  skip: "Preskoči",
  oneOfTwo: "1 od 2",
  openApps:
    "Neposredno lahko odprete aplikacije, za katere ste že registrirani. Prav tako lahko zahtevate dostop do drugih aplikacij, ki bi vam lahko bile pomembne.",
  requiredFields:
    "Prosimo izpolnite obvezna polja: Naziv, Ime, Priimek",
  stage: "Korak",
  chooseOne: "(Prosimo označite vsaj 1 polje)",
  required: "*obvezna polja",
  lengthCsNumber: "Dolžina številke stranke: 6-10 števk",
  waitForAdminApproval:
    "Hvala za prijavo v Bridgestone Plus nagradni program. Trenutno pregledujemo vašo prijavo. Prejeli boste potrditveni e-naslov, ko bo vaša prijava odobrena.",
  selectTyres: "SEKTOR DEJAVNOSTI IN PROFIL",
};

export default {
  messages,
};
